import { useCallback } from 'react';
import { Button } from 'react-bootstrap';

import { useUserContext } from '@/context/UserContext.tsx';
import { useAppDispatch } from '@/store/hooks.ts';
import { toggleWorkspaceCanTrade } from '@/store/workspace/slice.ts';

export function LockWorkspaceButton() {
  const dispatch = useAppDispatch();
  const userContextValue = useUserContext();

  const {
    tradePermission = 'disallowedByUserPermissions', // by default while we have no information about user
  } = userContextValue ?? {};

  const handleClick = useCallback(() => {
    dispatch(toggleWorkspaceCanTrade());
  }, []);

  return (
    <Button
      data-e2e="lock-workspace-btn"
      data-e2e-trade-permission={tradePermission}
      variant={tradePermission === 'allowed' ? 'flat-primary' : 'flat-danger'}
      className="btn-lg btn-icon"
      disabled={tradePermission === 'disallowedByUserPermissions'}
      onClick={handleClick}
    >
      <i className="icon my-1">{tradePermission === 'allowed' ? 'lock_open' : 'lock'}</i>
    </Button>
  );
}
